import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const Box = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  width: 100%;

  & > div + div {
    margin-left: ${(props) => props.theme.spacing.small};
  }

  &:last-child {
    justify-content: flex-end;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
  padding: 1rem 0;
`;
